module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/marketplacecommerceanalytics-2015-07-01.paginators.json
// module id = 728
// module chunks = 1